// ABOUTME: Maintains a ring buffer (max 10) of recent console.error/window.onerror/unhandledrejection.
// ABOUTME: getFeedbackContext() assembles {route, browser, viewport, buildVersion, consoleErrors} on submit.

const MAX_ERRORS = 10;
const MAX_LEN = 2000;

let buffer = [];
let installed = false;

const truncate = (s) => String(s).slice(0, MAX_LEN);

export const recordError = (message) => {
  buffer.push(truncate(message));
  if (buffer.length > MAX_ERRORS) {
    buffer = buffer.slice(buffer.length - MAX_ERRORS);
  }
};

export const getConsoleErrors = () => [...buffer];

// Installs the listeners once (idempotent). Call from app bootstrap.
export const installFeedbackContext = () => {
  if (installed || typeof window === "undefined") return;
  installed = true;

  const originalError = console.error;
  console.error = (...args) => {
    try {
      recordError(args.map((a) => (typeof a === "string" ? a : JSON.stringify(a))).join(" "));
    } catch (e) {
      // ignore serialization issues
    }
    originalError.apply(console, args);
  };

  window.addEventListener("error", (event) => {
    recordError(`${event.message} @ ${event.filename}:${event.lineno}:${event.colno}`);
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason && event.reason.message ? event.reason.message : String(event.reason);
    recordError(`unhandledrejection: ${reason}`);
  });
};

export const getFeedbackContext = () => ({
  route: typeof window !== "undefined" ? window.location.pathname + window.location.search : "",
  browser: typeof navigator !== "undefined" ? navigator.userAgent : "",
  viewport: typeof window !== "undefined" ? `${window.innerWidth}x${window.innerHeight}` : "0x0",
  buildVersion: process.env.REACT_APP_BUILD_VERSION || "dev",
  consoleErrors: getConsoleErrors(),
});

// Test-only: reset buffer between tests.
export const __resetForTest = () => {
  buffer = [];
  installed = false;
};
